import PropTypes from "prop-types";
import { useState } from "react";
import { TbSettingsSearch } from "react-icons/tb";
import { VscOrganization } from "react-icons/vsc";
import { Link } from "react-router";
import CBSGCharLoader from "../../Page/CBSGCharLoader";

const AboutSection = ({ AboutData }) => {
  const [loading, setLoading] = useState(true);

  const {
    about_text,
    organization_development_image,
    organization_development_text,
    research_evaluation_image,
    research_evaluation_text,
  } = AboutData;

  if (AboutData === undefined) {
    return (
      <div className="flex justify-center items-center h-screen ">
        <CBSGCharLoader />
      </div>
    );
  }

  return (
    <div
      className="mx-auto px-4 border-2 my-20 p-10 border-base_500 md:mx-11 lg:mx-24 mb-4 text-base_600 bg-white rounded font-medium"
      data-aos="zoom-in"
    >
      <p
        className="font-extrabold pb-2 rounded-md w-full bg-gradient-to-tr from-base_900 to-base_500 bg-clip-text text-transparent text-xl"
        data-aos="fade-right"
      >
        WHAT WE DO
      </p>

      <div
        dangerouslySetInnerHTML={{ __html: about_text }}
        className="text-base font-normal text-blue-950"
        data-aos="fade-right"
      />

<div className="grid grid-cols-1 gap-10 mt-5">
  {/* Organization & Institution Development */}
  <div className="flex flex-col-reverse md:flex-row items-center md:items-start md:justify-between gap-5">
    <div className="md:w-1/2 space-y-3" data-aos="fade-left">
      <Link to="/Services/Organization-Development">
        <p className="text-sm md:text-base lg:text-xl font-semibold bg-gradient-to-tr from-base_500 to-base_900 text-white flex items-center justify-end px-4 py-2 gap-3 rounded">
          <span className="text-xl">
            <VscOrganization />
          </span>
          <span className="text-right">ORGANIZATION AND INSTITUTION DEVELOPMENT</span>
        </p>
      </Link>
      <div
        className="text-base font-sans font-normal text-blue-950 text-justify leading-relaxed tracking-wide hyphens-auto"
        dangerouslySetInnerHTML={{ __html: organization_development_text }}
      />
    </div>
    <div className="md:w-1/2 flex justify-center md:justify-center" data-aos="fade-left">
      <img
        src={organization_development_image}
        alt="Organizational Development"
        className="w-2/3 md:w-[65%] object-contain"
      />
    </div>
  </div>

  {/* Research and Evaluation */}
  <div className="flex flex-col md:flex-row items-center md:items-start md:justify-between gap-5">
    <div className="md:w-1/2 flex justify-center md:justify-center" data-aos="fade-right">
      <img
        src={research_evaluation_image}
        alt="Research and Evaluation"
        className="w-2/3 md:w-[65%] object-contain"
      />
    </div>
    <div className="md:w-1/2 space-y-3" data-aos="fade-right">
      <Link to="/Services/Research&Evaluation">
        <p className="text-sm md:text-base lg:text-xl font-semibold bg-gradient-to-tr from-base_900 to-base_500 text-white flex items-center justify-start px-4 py-2 gap-3 rounded">
          <span className="text-xl">
            <TbSettingsSearch />
          </span>
          <span>RESEARCH AND EVALUATION</span>
        </p>
      </Link>
      <div
        className="text-base font-sans font-normal text-blue-950 text-justify leading-relaxed tracking-wide hyphens-auto"
        dangerouslySetInnerHTML={{ __html: research_evaluation_text }}
      />
    </div>
  </div>
</div>

    </div>
  );
};

export default AboutSection;
AboutSection.propTypes = {
  AboutData: PropTypes.shape({
    about_text: PropTypes.string,
    organization_development_image: PropTypes.string,
    organization_development_text: PropTypes.string,
    organization_development_title: PropTypes.string,
    research_evaluation_image: PropTypes.string,
    research_evaluation_text: PropTypes.string,
  }).isRequired,
};
